import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=7a57a31c&scoped=true"
import script from "./AccountStatement.vue?vue&type=script&lang=js"
export * from "./AccountStatement.vue?vue&type=script&lang=js"
import style0 from "./AccountStatement.vue?vue&type=style&index=0&id=7a57a31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a57a31c",
  null
  
)

export default component.exports